import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mailto',
    standalone: false
})
export class MailtoPipe implements PipeTransform
{
    transform (value: string): string
    {
        return `mailto:${value}`;
    }
}
